import { AsLeftTestTableDeviationEu2Formula } from './P621.formulas';
import { AsLeftResultFormula } from '../../../TestResultSection/Data/P621/P621.formulas';
import { getInstrumentUnit } from '../../../AsFoundTestTableSection/Data/S72/S72.formula';
import { Result } from 'journeys/portal/Forms/Sections.constants';

export const disableAsLeftTestFields = (formData) => disableAsLeftTestRequired(formData) || formData.F619AsLeftTestRequired === 'NO';
export const disableAsLeftTestRequired = (formData) => formData.F102AftResult === 'PASS';

export const AsLeftTestTableSectionDataP621 = (formName, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'ASLeftTest',
                    label: 'As-Left Test',
                    isLabel: true,
                    xs: 4,
                    fontWeight: '700',
                    labelWidth: '100%',
                    padding: '7px 0 5px 6px',
                    fontSize: '9pt'
                },
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 1
                },
                {
                    key: 'F1056AltObservedTripSetpointLabel',
                    label: `Observed Trip Setpoint ${getInstrumentUnit(formData)}`,
                    isLabel: true,
                    xs: 2,
                    fontWeight: '600',
                    textAlign: 'center',
                    labelWidth: '100%',
                    padding: '7px 0 5px 3px',
                    fontSize: '9pt'
                },
                {
                    key: 'F185AltHmireadingLabel',
                    label: 'HMI Indication',
                    isLabel: true,
                    xs: 3,
                    fontWeight: '600',
                    labelWidth: '100%',
                    textAlign: 'center',
                    padding: '7px 0 5px 0',
                    fontSize: '9pt'
                },
                {
                    key: 'F186AltDeviationLabel',
                    label: `Deviation  ${getInstrumentUnit(formData)}`,
                    isLabel: true,
                    fontWeight: '600',
                    xs: 2,
                    textAlign: 'center',
                    labelWidth: '100%',
                    padding: '7px 0 5px 0',
                    fontSize: '9pt'
                }]
        },
        {
            key: 2,
            fields: [
                {
                    key: 'F652asLeftTripPoint',
                    label: `Trip Setpoint for Test  ${getInstrumentUnit(formData)}`,
                    value: disableAsLeftTestFields(formData) ? '' : formData.F652asLeftTripPoint,
                    isDisabled: disableAsLeftTestFields(formData),
                    isRequired: !disableAsLeftTestFields(formData),
                    readOnly: disableAsLeftTestFields(formData),
                    xs: 4,
                    type: 'number',
                    maxLength: '10',
                    labelWidth: '52.7%',
                    width: '52%',
                    height: '1.91rem',
                    marginLeft: '6px',
                    textAlign: 'center',
                },
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 1
                },
                {
                    key: 'F1056AltObservedTripSetpoint',
                    value: disableAsLeftTestFields(formData) ? '' : formData.F1056AltObservedTripSetpoint,
                    isDisabled: disableAsLeftTestFields(formData),
                    isRequired: !disableAsLeftTestFields(formData),
                    readOnly: disableAsLeftTestFields(formData),
                    type: 'number',
                    xs: 2,
                    width: '100%',
                    maxLength: '10',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: '1.91rem',
                    borderRight: '0',
                },
                {
                    key: 'F185AltHmireading',
                    value: disableAsLeftTestFields(formData) ? '' : formData.F185AltHmireading,
                    isDisabled: disableAsLeftTestFields(formData),
                    isRequired: !disableAsLeftTestFields(formData),
                    readOnly: disableAsLeftTestFields(formData),
                    isDropdown: !disableAsLeftTestFields(formData),
                    placeholder: 'Select HMI Indication',
                    options: [{ name: 'Select HMI Indication', value: '' },
                    { name: 'Equipment Tripped', value: 'Equipment Tripped' },
                    { name: 'Equipment Not Tripped', value: 'Equipment Not Tripped' }],
                    xs: 3,
                    width: '100%',
                    labelWidth: '0',
                    textAlign: 'center',
                    height: disableAsLeftTestFields(formData) ? '1.92rem' : '2.28rem',
                },
                {
                    key: 'F186AltDeviation',
                    value: disableAsLeftTestFields(formData) ? ' ' : AsLeftTestTableDeviationEu2Formula(formData),
                    isDisabled: disableAsLeftTestFields(formData),
                    xs: 2,
                    labelWidth: '0',
                    width: '100%',
                    textAlign: 'center',
                    height: '1.91rem',
                    borderLeft: '0',
                    borderRight: '0',
                    readOnly: true,
                    inputMarginRight: '4px'
                }]
        },
        {
            key: 3,
            fields: [
                {
                    key: 'Nodata2',
                    isLabel: true,
                    xs: 8
                },
                {
                    key: 'F103AltResult',
                    label: Result.AS_LEFT_RESULT_LABEL,
                    value: disableAsLeftTestFields(formData) ? '' : AsLeftResultFormula(formData),
                    isDisabled: disableAsLeftTestFields(formData),
                    readOnly: true,
                    isCalculatedNew: true,
                    xs: 4,
                    labelWidth: '99%',
                    fontWeight: '700',
                    direction: 'rtl',
                    width: '100%',
                    inputMarginRight: '4px',
                    marginRight: '0.5rem',
                    borderBottom: '0',
                    borderRight: '0',
                    height: '1.92rem',
                    textAlign: 'center',
                    marginBottom: '4px',
                    marginTop: '0',
                    borderTop: '0',
                }
            ]
        }
    ]
});
